<template>
    <div class="container">
        <div>
            订单号：{{ ticketNumber }}
        </div>
        <div class="content">
            <div class="title">用户评价</div>
            <van-empty
                v-if="!list.length"
                description="暂无用户评价"
            ></van-empty>
            <div v-else>
                <div v-for="item in list" :key="item.id" class="card">
                    <div class="time">评价时间：{{ item.createdAt }}</div>
                    <div v-for="formItem in item.parameters" :key="formItem.name" class="box">
                        <div class="left">{{ formItem.title }}</div>
                        <div class="right">{{ formItem.label }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="chat-btn">
            <van-button
                type="info"
                @click="goChat"
                >进入聊天
            </van-button>
        </div>
    </div>
</template>
<script>
import { GetChildrentTickets } from '@custouch/proxy-use'
import dayjs from 'dayjs'
const { VUE_APP_TICKET_SAMPLE_ID, VUE_APP_TICKET_SAMPLE_CHILDREN_ID } = window.env
export default {
    props: {
        ticketNumber: {
            type: String
        }
    },
    data(){
        return {
            projectId: VUE_APP_TICKET_SAMPLE_ID,
            list: []
        }
    },
    methods: {
        async init(){
            const { data } = await GetChildrentTickets({
                projectId: this.projectId,
                childrenProjectId: VUE_APP_TICKET_SAMPLE_CHILDREN_ID,
                ticketNumber: this.ticketNumber
            })
            this.list = data.map((t) => {
                return {
                    id: t.id,
                    createdAt: dayjs(t.createdAt).format('YYYY-MM-DD HH:mm:ss'),
                    parameters: t.parameters.filter(s=>s.type === 'radio')
                }
            })
        },
        goChat() {
            this.$router.push({
                name: 'questionDetailFromSample',
                params: { ticketNumber: this.ticketNumber, projectId: this.projectId }
            })
        }
    },
    created(){
        this.init()
    },
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/mixin';
.container{
    padding: 0.78rem 0.8rem;
    color: @black;
    background: #FEFEFE;
    .content{
        margin-top: @spacing;
        .title{
            color: #383838;
            font-size: 0.8rem;
            letter-spacing: 0.01rem;
            display: flex;
            align-items: center;
            margin-bottom: 0.8rem;
            &::before {
                content: '';
                display: block;
                width: 0.3rem;
                height: 0.8rem;
                background: #004E9E;
                margin-right: 0.5rem;
            }
        }
        .card{
            background: @white;
            margin-bottom: 0.8rem;
            .time{
                background: #00549E;
                color: @white;
                padding: 0.3rem 0.8rem 0.35rem 0.8rem;
            }
            .box{
                display: flex;
                align-items: center;
                font-size: 0.6rem;
                line-height: 0.95rem;
                border: 1px solid #F1F1F1;
                border-top: none;
                .left{
                    width: 11.78rem;
                    flex-shrink: 1;
                    padding:  0.6rem 0.83rem;
                    border-right: 1px solid #F1F1F1;
                }
                .right{
                    flex: 1;
                    padding:  0.6rem 0.8rem;
                    text-align: right;
                    color: #8B8E90;
                }
            }
        }
    }
    .chat-btn{
        display: flex;
        justify-content: flex-end;
    }
}
</style>